import { EventEmitter, Injectable } from "@angular/core";
import { Platform } from "@ionic/angular";
import { BackendService } from "@tg4/http-infrastructure";
import { GlobalizationConfig } from "../interfaces/globalization-config.interface";
const DefaultLanguage = "en-US";
@Injectable()
export class TranslationService {
    public languageChanged$ = new EventEmitter<string>();

    private _selectedLanguage: string = DefaultLanguage;
    private _translationsJson;
    private localStorageLanguageKey = "userSelectedLanguage";

    private _translationFallback = {
        "pt-BR": {
            "login.noUserInfo": "Usuário não encontrado para esse e-mail",
            "generic.serverError": "Ocorreu um erro, por favor tente novamente mais tarde",
        },
        "es-ES": {
            "login.noUserInfo": "Usuario no encontrado para este email",
            "generic.serverError": "An error has occurred, please try again later",
        },
        "en-US": {
            "login.noUserInfo": "User not found for the provided email",
            "generic.serverError": "Un error ha ocurrido, por favor intente nuevamente más tarde",
        },
    };

    private _accessByComponent = {
        "pt-BR": "Não é possível acessar essa área através desse método",
        "es-ES": "You cannot access this area through this method",
        "en-US": "No es posible acceder a esta área a través de este método",
    };

    constructor(
        private platform: Platform,
        private _httpService: BackendService,
    ) {
        // this.platform.ready().then(async () => {
        //     await this.initializeLanguageSettings();
        // });
    }

    public async initializeLanguageSettings() {
        const savedLanguage = localStorage.getItem(this.localStorageLanguageKey);
        await this.changeSelectedLanguage(savedLanguage ? savedLanguage : "pt-BR");
    }

    public getSelectedLanguage(): string {
        return this._selectedLanguage;
    }

    public getStoredLanguage() {
        return localStorage.getItem(this.localStorageLanguageKey);
    }

    public async changeSelectedLanguage(language: string): Promise<void> {
        this._selectedLanguage = language;
        this._translationsJson = (await this._getJSON(language)).data;
        localStorage.setItem(this.localStorageLanguageKey, language);
        this.languageChanged$.next(language);
    }

    public getTranslation(translationKey: string): string {
        if (!this._translationsJson || !this._translationsJson[translationKey]) return this._getTranslationFromFallback(translationKey);
        return this._translationsJson[translationKey].replace(/\n/g, "\n").replace(/\\n/g, "\n");
    }

    public getTranslationByConfig(config: GlobalizationConfig, property: string): string {
        return config[this.getSelectedLanguage()][property];
    }

    public getTranslationForCannotAccessByComponent(property: string) {
        return this._accessByComponent[property];
    }

    private _getJSON(language: string): Promise<any> {
        return this._httpService.get("getStringResources", [], [{ name: "culture", value: language }]).toPromise();
    }

    private _getTranslationFromFallback(key: string): string {
        try {
            return this._translationFallback[this._selectedLanguage][key] || key;
        } catch (error) {
            return key;
        }
    }

    public hasTranslation(translationKey: string): boolean {
        return !(!this._translationsJson || !this._translationsJson[translationKey]);
    }
}
